import { ApiFileUploadTypes } from 'api/types/ApiFileUploadTypes';
import { FilePicker } from 'components/FilePicker';

import { Field } from './Field/Field';

type Props = {
  analyticsLabel?: boolean;
  downloadAttachment?: boolean;
  fileType?: ApiFileUploadTypes;
  name: string;
  label?: string;
  description?: string;
  message?: string;
  'aria-label'?: string;
  'data-qa-id'?: string;
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onUpdateValue?: (...args: Array<any>) => any;
  large?: boolean;
  accept?: string;
  listingType?: string;
  disabled?: boolean;
  type: 'URL' | 'FILE';
};

export function RequestedAttachmentUserField({
  analyticsLabel,
  downloadAttachment,
  fileType = 'LISTING_APPLICATION',
  name,
  label,
  description,
  onUpdateValue,
  'data-qa-id': qaId,
  large,
  type,
  listingType,
  disabled,
  ...props
}: Props) {
  if (type !== 'FILE') return null;
  const subName = `${name}.${type.toLowerCase()}`;
  return (
    <Field
      customErrorMatch={(errors) => errors[name] || errors[subName]}
      name={name}
      label={label}
      description={description}
      inputProps={props}
      renderInput={({ value, qaId: autoQaId, updateValue }) => (
        <FilePicker
          disabled={disabled}
          downloadAttachment={downloadAttachment}
          fileId={value?.s3FileId}
          fileType={fileType}
          data-qa-id={qaId || autoQaId}
          onChange={(e) => {
            if (onUpdateValue) {
              onUpdateValue(e ? { type: 'FILE', s3FileId: e } : null);
            } else {
              updateValue(e ? { type: 'FILE', s3FileId: e } : null);
            }
          }}
          name={name}
          large={large}
          extraAnalyticsData={{
            context: 'Listing Application Form',
            listing_type: listingType,
            file_label: analyticsLabel || label,
          }}
          maxSize={10}
        />
      )}
    />
  );
}
